// extracted by mini-css-extract-plugin
export default {"content":"about_content__77lec","desc":"about_desc__BfnW1","link":"about_link__tfhzg"};